import { render, staticRenderFns } from "./TenantInfo.vue?vue&type=template&id=dbf768e2&"
import script from "./TenantInfo.vue?vue&type=script&lang=js&"
export * from "./TenantInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports